// extracted by mini-css-extract-plugin
module.exports = {"blogCard":"blog-item-module--blog-card--3H3_B","cardImg":"blog-item-module--card-img---JL1B","cardTitle":"blog-item-module--card-title--1lbDN"};